import { connect } from 'react-redux'

import { getIdentityLastUserActivity } from 'store/entities/identity/selectors'
import { USER_ACTIVITY_DONE_PANEL_FORM as FORM_NAME } from 'app/constants/activities'
import UserActivityDonePanel from 'app/domains/common/UserActivityDonePanel'

const mapStateToProps = state => ({
  activityId: getIdentityLastUserActivity(state).get('id'),
  form: `${FORM_NAME}ForYesterdayActivity`,
  isFavorite: getIdentityLastUserActivity(state).get('isFavorite'),
  isYesterday: true,
})

export default connect(mapStateToProps)(UserActivityDonePanel)
